import React, { memo } from 'react';
import { Modal, Backdrop, Fade, Paper, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import Loading from 'components/loading';
import AlertCustom from 'components/alertCustom';
import useModalViewCommunication from './useModalViewCommunication';

import {
    Main,
    Container,
    Title,
    TitleIcon,
    HeaderMessage,
    Status,
    Text,
    Data,
    Icon,
    GroupMessages,
    ListMessage,
    ButtomDowload,
    ButtomLinkDownload,
} from './Styled';

import ComunImg from '../../../screens/messages/images/talk.png';

const ModalViewCommunication = ({ showModal, setShowModal, viewCommunicationId }) => {
    const {
        transitionIn,
        loadingPage,
        comunicacao,
        currentLang,
        translate,
        Utils,
        messageAlert,
        openAlert,
        setOpenAlert,
        handleGetFileName,
    } = useModalViewCommunication({
        viewCommunicationId,
        onClose: () => setShowModal(false),
    });

    const handleClose = () => {
        setShowModal(false);
    };

    return (
        <Modal
            open={showModal}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={showModal}>
                <Paper
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: '95%', sm: '90%', md: '80%', lg: '60%' },
                        maxHeight: '90vh',
                        overflow: 'auto',
                        p: 4,
                        boxShadow: 24,
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                    }}
                >
                    <Box display="flex" justifyContent="flex-end">
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {loadingPage ? (
                        <Loading />
                    ) : (
                        <Main>
                            <Container>
                                <Title transition={transitionIn}>
                                    <TitleIcon src={ComunImg} />
                                    {translate('messages.title')}
                                </Title>

                                {!comunicacao || Object.keys(comunicacao).length === 0 ? (
                                    <Text center noContent>
                                        {translate('messages.noContent')}
                                    </Text>
                                ) : (
                                    <>
                                        <HeaderMessage transition={transitionIn}>
                                            <Status type={comunicacao.cmit_status}>
                                                {translate(`messages.status.${comunicacao.cmit_status.toLowerCase()}`)}
                                            </Status>
                                            <Text bold="bold">
                                                {comunicacao.cmit_id_comunicacao_interna} {comunicacao.cmit_area}
                                            </Text>
                                            <Text>
                                                {comunicacao.cmit_tipo} -{' '}
                                                {moment(comunicacao.cmit_mes_referencia).format(
                                                    Utils.formatDataIsLang(currentLang),
                                                )}
                                            </Text>
                                            <Text>{'COMENTARIO:' + comunicacao.cmit_comentario}</Text>
                                        </HeaderMessage>

                                        <GroupMessages>
                                            <ListMessage transition={transitionIn}>
                                                <Text>{comunicacao.cmit_comentario}</Text>
                                                {comunicacao.arquivo &&
                                                    comunicacao.arquivo.length > 0 &&
                                                    comunicacao.arquivo.map((foto, index) => (
                                                        <ButtomDowload key={index} transition={transitionIn}>
                                                            <ButtomLinkDownload
                                                                key={index}
                                                                href={foto.cmia_arquivo}
                                                                className="btn-green"
                                                                download={handleGetFileName(foto.cmia_arquivo)}
                                                                target="_blank"
                                                                title={handleGetFileName(foto.cmia_arquivo)}
                                                            >
                                                                <Icon className="icon icon-download" /> Ver Anexo
                                                            </ButtomLinkDownload>
                                                        </ButtomDowload>
                                                    ))}
                                                <Data>
                                                    {moment(comunicacao.cmit_dh_registro).format(
                                                        Utils.formatDataHoraIsLang(currentLang),
                                                    )}
                                                </Data>
                                            </ListMessage>

                                            {comunicacao.resposta &&
                                                comunicacao.resposta.map((resp) => (
                                                    <ListMessage
                                                        key={resp.cmir_id_comunicacao_resposta}
                                                        transition={transitionIn}
                                                        me={!resp.cmir_resposta_solicitante}
                                                    >
                                                        <Text>{resp.cmir_resposta}</Text>

                                                        {resp.cmir_arquivo && (
                                                            <ButtomDowload transition={transitionIn}>
                                                                <ButtomLinkDownload
                                                                    href={resp.cmir_arquivo}
                                                                    className="btn-green"
                                                                    download={handleGetFileName(resp.cmir_arquivo)}
                                                                    target="_blank"
                                                                    title={handleGetFileName(resp.cmir_arquivo)}
                                                                >
                                                                    <Icon className="icon icon-download" /> Ver Anexo
                                                                </ButtomLinkDownload>
                                                            </ButtomDowload>
                                                        )}
                                                        <Data>
                                                            {resp.cmir_resposta_solicitante ? 'Você' : 'Grupo Altum'}{' '}
                                                            {' em: '}
                                                            {moment(resp.cmir_dh_registro).format(
                                                                Utils.formatDataHoraIsLang(currentLang),
                                                            )}
                                                        </Data>
                                                    </ListMessage>
                                                ))}
                                        </GroupMessages>
                                    </>
                                )}
                            </Container>
                        </Main>
                    )}
                    <AlertCustom
                        message={messageAlert}
                        openMessage={openAlert}
                        closeMessage={() => setOpenAlert(false)}
                        transition="down"
                        origin={{ vertical: 'top', horizontal: 'right' }}
                    />
                </Paper>
            </Fade>
        </Modal>
    );
};

export default memo(ModalViewCommunication);
